"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PlayButton;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _text = _interopRequireDefault(require("@ux/text"));
/* eslint-disable max-len */

function Play(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: "52",
    height: "52",
    viewBox: "0 0 52 52"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.6 32.75c-.34 0-.67-.09-.96-.27-.54-.33-.89-.94-.89-1.58v-9.81c0-.68.4-1.34 1.01-1.65.61-.31 1.38-.24 1.93.16l6.66 4.9c.47.34.75.91.75 1.49s-.29 1.14-.75 1.49l-6.66 4.9c-.32.23-.7.36-1.09.36Z"
  }));
}
function Pause(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: "52",
    height: "52",
    viewBox: "0 0 52 52"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.04 32.67a.787.787 0 0 0 .79-.79V20.8a.787.787 0 0 0-.79-.79.787.787 0 0 0-.79.79v11.08a.787.787 0 0 0 .79.79Zm5.92 0a.787.787 0 0 0 .79-.79V20.8a.787.787 0 0 0-.79-.79.787.787 0 0 0-.79.79v11.08a.787.787 0 0 0 .79.79Z"
  }));
}
const Button = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "Button",
  class: "pl-b13eno95"
});
const PlayButtonWrapper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "PlayButtonWrapper",
  class: "pl-pczu21e"
});
const Label = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Label",
  class: "pl-l7rd0gp"
});

/**
 * Play Button component.
 * @module PlayButton
 *
 * @param {Object} props React props
 * @param {function} props.handlePlay handlePlay
 * @param {Boolean} props.pause pause
 * @param {Boolean} props.invert invert
 * @param {String} props.dataCy dataCy
 * @param {String} props.buttonText buttonText
 * @returns {React.ReactElement} Play Button component
 * @public
 */

function PlayButton({
  handlePlay,
  pause,
  partial,
  invert = false,
  size = 'large',
  dataCy = 'play-button',
  buttonText
}) {
  return /*#__PURE__*/_react.default.createElement(Button, (0, _extends2.default)({
    "data-cy": dataCy,
    "data-partial": partial || (invert ? 'dark1' : ''),
    "aria-label": "play button",
    onClick: handlePlay
  }, _patternLibraryUtils.tracking.create(pause ? 'pause' : 'play', true, false)), /*#__PURE__*/_react.default.createElement(PlayButtonWrapper, {
    "data-size": size,
    "data-partial": invert ? 'light1' : 'dark1'
  }, pause ? /*#__PURE__*/_react.default.createElement(Pause, null) : /*#__PURE__*/_react.default.createElement(Play, null)), buttonText && /*#__PURE__*/_react.default.createElement(Label, {
    "data-partial": invert ? 'dark1' : ''
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    text: buttonText,
    ariaLabel: "play-video"
  })));
}
PlayButton.propTypes = {
  handlePlay: _propTypes.default.func,
  pause: _propTypes.default.bool,
  _name: _propTypes.default.string,
  partial: _propTypes.default.string,
  invert: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['large', 'small']),
  dataCy: _propTypes.default.string,
  buttonText: _propTypes.default.string
};